import { loadQuery } from 'react-relay';
import { CONTACTS_QUERY } from 'services/contact/contact.relay.services';
import { ContactOrdering, contactsQuery } from 'services/contact/__generated__/contactsQuery.graphql';

import { getAccountId, getUserId } from 'lib/utils/authentication';
import RelayEnvironment from 'lib/utils/relay';

export const ClientsPreloadData = () => {
  const userId = getUserId() ?? '';
  const accountId = getAccountId() ?? '';

  const queryFilter = {
    or: {
      accountId: { equalTo: accountId },
      contactTeamMembers: {
        teamMember: { memberUserId: { equalTo: userId } },
      },
    },
    status: { equalTo: 'active' },
    deletedAt: { isNull: true },
  };
  const pageSize = 20;
  const ordering: ContactOrdering[] = [{ sort: 'CREATED_AT', direction: 'DESC' }];

  return {
    queryFilter,
    pageSize,
    ordering,
    contactsQueryRef: loadQuery<contactsQuery>(RelayEnvironment, CONTACTS_QUERY, {
      first: pageSize,
      ordering,
      filter: {
        where: queryFilter,
      },
    }),
  };
};

export type ClientsPreloadDataType = ReturnType<typeof ClientsPreloadData>;
